/* ==========================================================================
   GemofU: free WhatsApp buttons (no app). Every button opens a chat with the
   store's WhatsApp number with a message already typed.
   1. Floating chat button on every page (moves up on phones when the sticky
      Add to Cart bar is showing).
   2. Product page: "Ask or order on WhatsApp" under Add to Cart, with the
      product name, chosen option, price and link.
   3. Cart page and cart drawer: "Questions before you pay?" line under the
      checkout button, with the items in the bag.
   Number and texts are set in snippets/gou-plus.liquid (window.GOU_WA).
   ========================================================================== */
(function () {
  'use strict';
  var WA = window.GOU_WA || {};
  var NUM = String(WA.number || '').replace(/\D/g, '');
  if (!NUM) return;

  var ICON = '<svg viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.4c-2.1 0-4.1-.6-5.9-1.7l-.4-.3-3.8 1.2 1.2-3.7-.3-.4a10.4 10.4 0 0 1-1.7-5.7C5.1 9.9 10 5.1 16 5.1s10.9 4.8 10.9 10.7S22 26.4 16 26.4zm6-8c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6.3-.5c.1-.2 0-.4 0-.6l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.2 1.4 3.4c.2.2 2.4 3.6 5.8 5 .8.4 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z"/></svg>';

  function link(text) {
    return 'https://wa.me/' + NUM + '?text=' + encodeURIComponent(text);
  }
  function open(text) {
    window.open(link(text), '_blank', 'noopener');
  }
  function money(cents) {
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN');
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---- 1. floating button --------------------------------------------- */
  function floatBtn() {
    if (document.querySelector('.gou-wa-float')) return;
    var a = document.createElement('a');
    a.className = 'gou-wa-float';
    a.href = link(WA.hello || 'Hi GemofU, I have a question.');
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat with us on WhatsApp');
    a.innerHTML = ICON + '<span class="gou-wa-float__tip">Chat with us</span>';
    document.body.appendChild(a);
  }

  /* ---- 2. product page ------------------------------------------------- */
  function productBtn() {
    var right = document.querySelector('.product__section-right');
    var pj = document.querySelector('script.product-json');
    if (!right || !pj || right.querySelector('.gou-wa-ask')) return;
    var product;
    try { product = JSON.parse(pj.textContent); } catch (e) { return; }
    var form = right.querySelector('form.product__form-buttons, .product__form-buttons');
    if (!form) return;
    var idInput = right.querySelector('#formVariantId') || right.querySelector('input[name="id"]');

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gou-wa-ask';
    b.innerHTML = ICON + '<span>Ask or order on WhatsApp</span>';
    var after = right.querySelector('.gou-dispatch') || form;
    after.insertAdjacentElement('afterend', b);

    b.addEventListener('click', function () {
      var id = idInput ? String(idInput.value) : '';
      var v = product.variants.filter(function (x) { return String(x.id) === id; })[0] || product.variants[0];
      var name = product.title + (v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '');
      var url = location.origin + '/products/' + product.handle + (v ? '?variant=' + v.id : '');
      open('Hi GemofU, I would like to order / ask about:\n' + name +
        (v ? '\nPrice: ' + money(v.price) : '') + '\n' + url);
    });
  }

  /* ---- 3. cart page and drawer ---------------------------------------- */
  function cartHelp() {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      var box = btn.parentNode;
      if (!box || box.querySelector('.gou-wa-cart')) return;
      var p = document.createElement('p');
      p.className = 'gou-wa-cart';
      p.innerHTML = 'Questions before you pay? <button type="button">' + ICON + '<span>Chat on WhatsApp</span></button>';
      btn.insertAdjacentElement('afterend', p);
      p.querySelector('button').addEventListener('click', function () {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var lines = (c.items || []).map(function (i) {
              return '- ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : '') + ' x ' + i.quantity;
            });
            open('Hi GemofU, I have a question about my cart:\n' + lines.join('\n') + '\nTotal: ' + money(c.total_price));
          })
          .catch(function () { open('Hi GemofU, I have a question about my cart.'); });
      });
    });
  }

  ready(function () {
    floatBtn();
    productBtn();
    cartHelp();
    // gou-plus.js adds the dispatch line after load; place the button below it.
    setTimeout(function () {
      var b = document.querySelector('.gou-wa-ask'), d = document.querySelector('.gou-dispatch');
      if (b && d && d.nextElementSibling !== b) d.insertAdjacentElement('afterend', b);
    }, 800);
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(cartHelp, 300); })
      .observe(document.body, { childList: true, subtree: true });
  });
})();
